import { getNewsPosts } from "./firebase";

export function getNewsPostsAction() {
  return dispatch => {
    dispatch({
      type: "GET_NEWS_POSTS"
    });
    getNewsPosts()
      .then(posts =>
        dispatch({ type: "GET_NEWS_POSTS_SUCCESS", payload: posts })
      )
      .catch(e => {
        console.log(e);
        dispatch({ type: "GET_NEWS_POSTS_ERROR" });
      });
  };
}
